import {defineCustomElement} from 'extensions/ui-utils';
import {html, LitElement} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import stylesheet from './x-tooltip.scss?as=stylesheet';

export class Tooltip extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			disabled: {
				type: Boolean
			},
			placement: {
				type: String
			}
		};
	}

	/**
	 * @type {import('tippy.js').Instance}
	 */
	_tippy;

	constructor () {
		super();

		/**
		 * @type {import('tippy.js').Placement}
		 */
		this.placement = 'top';

		/**
		 * @type {boolean}
		 */
		this.disabled = false;
	}

	createTippyInstance () {
		this._tippy = tippy(this.renderRoot?.querySelector('#js-container'), {
			allowHTML: true,
			arrow: false,
			content: () => `<slot name="content"></slot>`,
			interactive: true,
			placement: this.placement,
			zIndex: 2
		});
	}

	firstUpdated () {
		this.createTippyInstance();
	}

	updated (changedProperties) {
		if (changedProperties.has('disabled')) {
			if (this.disabled) {
				this._tippy?.disable();
			}
			else {
				this._tippy?.enable();
			}
		}

		if (changedProperties.has('placement')) {
			this._tippy.setProps({
				placement: this.placement
			});
		}
	}

	render () {
		const classes = {
			container: true,
			disabled: this.disabled
		};

		return html`
			<div id="js-container" class="${classMap(classes)}">
				<slot></slot>
			</div>
		`;
	}
};

defineCustomElement('x-tooltip', Tooltip);
